const fonts = {
  small: '2.2.rem',
  normal: '2.4rem',
  medium: '2.8rem',
  big: '2.9rem',
  huge: '4.2rem',
};

export default fonts;
